import { render } from "./AIAssistantHome.vue?vue&type=template&id=372ba014"
import script from "./AIAssistantHome.vue?vue&type=script&lang=js"
export * from "./AIAssistantHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__